import React, { useState } from 'react';
import { BringzzButton, BringzzImage, BringzzText, BringzzModal } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import { BringzzPageContainer, BringzzIcon } from "@bringzz/components";
import useRequest from 'hooks/useRequest';
import WAVE_IMAGE from 'assets/images/wave.png'

const AllowNotification = () => {
    const { backPress, navigate } = useNavigation();
    const { sendRequest, loading } = useRequest();
    const [showModal, setShowModal] = useState(false);

    const handleEnableNotifications = async () => {
        try {
            const response = await sendRequest({
                method: 'POST',
                url: '/module/user/toggleNotifications',
                data: { enable: true }
            });

            if (response?.status === 'success') {
                navigate('/pharmacy/register/faceid');
            } else {
                alert('Failed to update notification preferences');
            }
        
        } catch (error) {
            console.error('Notification error:', error);
            alert('An error occurred while updating notification settings');
        }
    };

    return (
        <>
            <BringzzPageContainer
                className="bg-white relative"  // Added relative here
                steps={true}
                activeStep={6}
                header={{
                    left: (
                        <BringzzIcon
                            size='22'
                            icon='IconChevronLeft'
                            folder='LineIcons'
                            className='cursor-pointer'
                            onClick={backPress}
                        />
                    ),
                    title: "Join Us",
                    right: <BringzzButton 
                        size='sm' 
                        className="border border-black" 
                        onClick={() => navigate('/pharmacy/register/faceid')}
                    >
                        Skip
                    </BringzzButton>
                }}
                footer={
                    <div className='pb-8 px-6'>
                        <BringzzButton
                            size='lg'
                            className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                            onClick={() => setShowModal(true)}
                            disabled={loading}
                        >
                            Turn on notifications
                        </BringzzButton>
                    </div>
                }
                authenticated={false}
            >
                <div className='relative flex justify-center bg-magic-lilac/20 z-0'>  {/* Added z-0 here */}
                    <div className='relative bg-white w-full bg-cover bg-center flex flex-col'>
                        <div className='flex-grow flex flex-col py-8 px-4'>
                            <div className='z-10 flex flex-col'>
                                <div className='pl-2 flex flex-col space-y-6 md:max-w-lg lg:max-w-xl xl:max-w-2xl'>
                                    <BringzzText tag='h1' className='pl-2 text-midnight-blue font-bold'>
                                        Get notifications
                                    </BringzzText>
                                    <BringzzText tag="h5" className="font-normal">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum consequat nisl eget ultricies mollis. Praesent eu sodales libero, sit amet commodo ante. Fusce ut mauris urna.
                                    </BringzzText>
                                </div>
                                <BringzzImage className='p-8 mt-4 z-0' src={WAVE_IMAGE} />  {/* Added z-0 here */}
                            </div>
                        </div>
                    </div>
                </div>
            </BringzzPageContainer>

            {showModal && (
                <BringzzModal
                    title="Bringzz would like to send you notifications"
                    description="Please allow notifications to receive important updates from us."
                    onCancel={() => setShowModal(false)}
                    onConfirm={async () => {
                        try {
                            await handleEnableNotifications();
                        } finally {
                            setShowModal(false);
                        }
                    }}
                    confirmButtonText={loading ? "Updating..." : "Allow"}
                    confirmButtonDisabled={loading}
                />
            )}
        </>
    );
};

export default AllowNotification;